//= Functions & Modules
// Others
import { boundMethod } from 'autobind-decorator';
import React from 'react';
import { nanoid } from 'nanoid/non-secure';
import { produce as immer } from 'immer';
import { NotificationType } from '../data/NotificationType';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark, faXmark } from '@fortawesome/free-solid-svg-icons';

type State = {
    notificationIDs: string[];
};

export class NotificationsSystem extends React.PureComponent<{}, State> {
    private notificationsData: { [key: string]: { type: NotificationType; message: string } };

    constructor(props: {}) {
        super(props);

        this.notificationsData = {};

        this.state = {
            notificationIDs: [],
        };
    }

    @boundMethod
    onClose(notificationID: string) {
        this.setState(
            immer(this.state, (draftState) => {
                draftState.notificationIDs.splice(draftState.notificationIDs.indexOf(notificationID), 1);
            }),
            () => {
                this.notificationsData[notificationID] = undefined;
            }
        );
    }

    @boundMethod
    addNotification(type: NotificationType, message: string) {
        const id = nanoid();

        this.notificationsData[id] = { type, message };

        this.setState(
            immer(this.state, (draftState) => {
                draftState.notificationIDs.push(id);
            }),
            () => {
                window.setTimeout(() => this.onClose(id), 5000);
            }
        );
    }

    render() {
        return (
            <div className="fixed top-16 right-4 flex flex-col gap-2 z-[9999] max-w-sm w-full pointer-events-none">
                {this.state.notificationIDs.map((notificationID) => {
                    const data = this.notificationsData[notificationID];
                    const isSuccess = data.type === NotificationType.SUCCESS;
                    return (
                        <div
                            key={notificationID}
                            className="pointer-events-auto flex items-start gap-3 p-3 rounded-xl shadow-lg bg-panel"
                            style={{
                                border: '1px solid rgba(255,255,255,0.08)',
                                borderLeft: `3px solid ${isSuccess ? '#22c55e' : '#ef4444'}`,
                            }}
                        >
                            <FontAwesomeIcon
                                icon={isSuccess ? faCircleCheck : faCircleXmark}
                                className={`mt-0.5 flex-shrink-0 ${isSuccess ? 'text-success' : 'text-danger'}`}
                            />
                            <span className="flex-1 text-sm text-title leading-snug">{data.message}</span>
                            <button
                                onClick={() => this.onClose(notificationID)}
                                className="flex-shrink-0 text-unselected1 hover:text-title transition-colors cursor-pointer"
                            >
                                <FontAwesomeIcon icon={faXmark} className="text-xs" />
                            </button>
                        </div>
                    );
                })}
            </div>
        );
    }
}
